<template>
  <div>
    <header-wrap @on-search="handleSearch"></header-wrap>
    <secord-nav></secord-nav>

    <!-- 面包屑导航栏 -->
    <div class="area_title">
      <h1>
        {{
          productCenterPage.searchTitle
            .replace("$keywords", searchKeywordsForTitle)
            .replace("$count", total)
        }}
      </h1>
      <div class="breadcrumb_wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{
            navbar.home
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span class="is-link" @click="onNav">{{
              productCenterPage.title
            }}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <span>{{ productCenterPage.searchListTitle }}</span>
          </el-breadcrumb-item>
        </el-breadcrumb>

        <div class="search-nav">
          <el-input
            v-model="searchKeywords"
            :placeholder="productCenterPage.searchPlaceholder"
          >
            <template slot="append">
              <el-button
                size="mini"
                class="el-icon-search"
                style="color: #333;"
                @click="handleSearch()"
              >
              </el-button>
            </template>
          </el-input>
          <!-- <div class="search-nav__tip">
            <i class="el-icon-info"></i>
            <span>{{ productCenterPage.searchTip }}</span>
          </div> -->
        </div>
      </div>
    </div>

    <!-- 产品列表 -->
    <div
      class="product_wrap2"
      v-loading.fullscreen="isSearching"
      :element-loading-text="search.searchLoadingText"
    >
      <template v-if="productList && productList.length > 0">
        <div
          class="product_block"
          v-for="(item, index) in productList"
          :key="index"
        >
          <img :src="item.image.split(',')[0]" alt="" class="product_img" />
          <div class="product_name">
            <span v-if="item[`${currentLang.prefix}no`]"
              >【{{ item[`${currentLang.prefix}no`] }}】</span
            >
            <span>{{ item[`${currentLang.prefix}title`] }}</span>
          </div>
          <div class="product_item">
            <div class="product_hover_name">
              {{ item[`${currentLang.prefix}title`] }}
            </div>
            <div
              class="product_hover_content"
              v-html="$convertPxToRem(item[`${currentLang.prefix}summary`])"
            ></div>
            <div class="dynamic_btn" @click="goProductDetails(item)">
              <span>MORE</span>
              <img
                class="more_btn"
                src="../../../assets/images/public/arrow1.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </template>
      <div class="search-none" v-else>
        <el-empty :description="search.searchResultNone"></el-empty>
      </div>
    </div>

    <!-- 分页 -->
    <div class="sc_pagi">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="prev, pager,next"
        :total="total"
      >
      </el-pagination>
    </div>

    <footer-wrap></footer-wrap>

    <feedback-popup></feedback-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getDataListByKeywordQuery } from "@/utils/http.js";

export default {

  data() {
    return {
      searchKeywords: "",
      searchKeywordsForTitle: "",
      productList: [],
      total: 0,
      currentPage: 1, // 当前页数，
      pageSize: 12, // 每一页显示的条数
      fromPage: "",
      isSearching: false
    };
  },

  computed: {
    ...mapGetters(["currentLang"]),
    productCenterPage() {
      return this.currentLang.config.productCenterPage;
    },
    productList() {
      return this.currentLang.config.productCenterPage.productList;
    },
    navbar() {
      return this.currentLang.config.navbar;
    },
    search() {
      return this.currentLang.config.search;
    }
  },
  created() {
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page);
    }
  },
  mounted() {
    const { query } = this.$route;
    if (query.from) {
      this.fromPage = query.from;
    }
    this.searchKeywords = this.$route.query.keywords
      ? this.$route.query.keywords
      : this.searchKeywords;
    this.fetchDataList();
  },
  methods: {
    onNav() {
      if (this.fromPage == "prod_center") {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: "/prod_center"
        });
      }
    },

    handleSearch(keywords) {
      console.log("keyword", keywords);
      if (keywords != undefined) {
        this.searchKeywords = keywords;
      }
      this.fetchDataList();
    },

    fetchDataList() {
      this.isSearching = true;
      const query = {
        type: "product",
        page: this.currentPage,
        limit: this.pageSize,
        keyword: this.searchKeywords
      };
      getDataListByKeywordQuery(query)
        .then(res => {
          console.log("搜索结果", res);
          if (res.code === 1) {
            this.productList = res.data.list ? res.data.list : [];
            this.total = res.data.count;
            if (res.data.count < 1 && this.productList.length < 1) {
              this.$message.warning(this.search.searchResultNone);
            }
            this.searchKeywordsForTitle = this.searchKeywords;
          } else {
            this.$message.error(err.msg);
          }
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.isSearching = false;
        });
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchDataList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$router.push({
        query: {
          ...this.$route.query,
          page: val
        }
      })
      this.fetchDataList();
       
    },

    // 跳转产品详情
    goProductDetails(info) {
      this.$router.push({
        path: "/prod_details",
        query: {
          id: info.cate_id,
          sonId: info.id,
          page: this.currentPage
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.product_hover_content >>> span {
  color: white !important;
}
.area_title {
  width: 100%;
  height: 160px;
  line-height: 160px;
  background: url("../../../assets/images/public/i12.jpg") no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center center;
  text-align: center;
  position: relative;
  h1 {
    color: white;
    font-weight: normal;
    font-size: 28px;
  }
  .breadcrumb_wrap {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    position: absolute;
    top: 15px;
    left: calc(50% - 600px);
    /deep/ .el-breadcrumb__item {
      span {
        color: #fff;
        font-size: 16px;
        font-weight: normal;
      }
    }

    .search-nav {
      line-height: 1.5;
    }

    .search-nav__tip {
      margin-top: 6px;
      text-align: left;
      font-size: 13px;
      font-weight: 300;
      color: rgba(255, 255, 255, 0.8);
    }

    /deep/ .el-input__inner {
      height: 36px;
      line-height: 36px;
      border: none;
      outline: none;
    }
  }
}
.area_cation {
  display: flex;
  justify-content: center;
  /deep/ .el-tabs {
    width: 100%;
    .el-tabs__header {
      height: 60px;
      line-height: 60px;
      background: #4b4b4b;
      border: 0;
      // width: 1200px;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-tabs__nav-wrap {
        height: 100%;
        margin-bottom: 0;
        .el-tabs__nav-scroll {
          height: 100%;
          .el-tabs__nav {
            height: 100%;
            border: 0;
            .el-tabs__item {
              height: 100%;
              color: #979797;
              border-left: none;
              border-bottom: none;
              padding: 0 25px;
              line-height: unset;
              font-size: 16px;
            }
            .is-active {
              background: #646464;
            }
          }
        }
      }
    }
  }
}
.product_wrap2 {
  width: 1200px;
  min-height: 50vh;
  height: auto;
  margin: 30px auto 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .product_block {
    width: calc((100% - 50px) / 3);
    margin-right: 25px;
    margin-bottom: 30px;
    position: relative;
    overflow: hidden;

    .product_img {
      width: 381.33px;
      height: 381.33px;
      border: 1px solid #dedede;
      display: flex;
      align-items: center;
      justify-content: center;
      object-fit: contain;
    }
    .product_name {
      padding: 25px;
      background: #f5f5f5;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .product_item {
      width: calc(100% - 50px);
      padding: 25px;
      background: #1a4769;
      position: absolute;
      bottom: 0;
      left: 0;
      color: #fff;
      // display: none;
      transform: translateY(100%);
      transition: all 0.4s;

      .product_hover_name {
        font-size: 18px;
      }
      .product_hover_content {
        margin-top: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .dynamic_btn {
        width: 140px;
        height: 45px;
        background: #e8363e;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        margin: 40px 0 0 0;
        cursor: pointer;
        .more_btn {
          width: 40px;
          margin-left: 10px;
        }
      }
    }
  }
  .product_block:nth-child(3n) {
    margin-right: 0;
  }
  .product_block:hover {
    .product_item {
      // display: block;
      transform: translateY(0%);
    }
  }

  .search-none {
    text-align: center;
    width: 100%;
    font-size: 24px;
    font-weight: 300;
    color: #999;
    font-style: italic;
  }
}
.sc_pagi {
  width: 500px;
  margin: 0 auto 50px;
  display: flex;
  justify-content: center;
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #e8363e;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home_product_center/productSearchList.vue